import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useVisitorAuth } from "@/context/VisitorAuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setVisitor } = useVisitorAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setVisitor(r.data);
        navigate(location.pathname, { replace: true, state: { visitor: r.data } });
      })
      .catch(() => navigate("/", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-navy" data-testid="auth-callback">
      <p className="text-sm font-semibold uppercase tracking-[0.25em] text-gold">Signing you in...</p>
    </main>
  );
}
